import 'jquery.cookie';

export default function() {
    const $panel = $('.contrast-version__panel');
    const panelHideClass = 'contrast-version__panel--hide';
    const switcherClass = 'contrast-version__switcher-btn span';
    const $switcher = $(`.${switcherClass}`);
    const $imageSwitcher = $('#image-switcher');
    const $rootTag = $('#contrast');
    const fontBtnClass = 'contrast-version__fontsize-btn';
    const fontBtnActiveClass = `${fontBtnClass}--active`;
    const kerningBtnClass = 'contrast-version__kerning-btn';
    const kerningBtnActiveClass = `${kerningBtnClass}--active`;
    const colorBtnClass = 'contrast-version__color-btn';
    const colorBtnActiveClass = `${colorBtnClass}--active`;
    const $themeSwitcher = $('.contrast-version__switcher-btn');
    const cookieName = 'contrast_view';
    const fontSizes = {
        normal: '13px',
        medium: '15px',
        large: '18px'
    };
    const kerningSizes = {
        normal: 'auto',
        medium: '1px',
        large: '2px'
    };
    const fonts = {
        openSans: 'Open Sans, sans-serif',
        arial: 'Arial',
        timesNewRoman: 'Times New Roman, serif'
    };
    const colors = {
        white: {
            text: '#000',
            text_rgb: '0,0,0',
            main: '#fff',
            main_rgb: '255,255,255'
        },
        black: {
            text: '#fff',
            text_rgb: '255,255,255',
            main: '#000',
            main_rgb: '0,0,0'
        },
        blue: {
            text: '#92b0e0',
            text_rgb: '146, 176, 224',
            main: '#1962d6',
            main_rgb: '25, 98, 214'
        }
    };
    const imagesBlocks = [
        'photogallery',
        'topical-section-wrapper',
        'special-section-wrapper',
        'header__logo-img',
        'team-member__image',
        'director-speech__img'
    ];
    let showImages = true;
    let fontName = 'openSans';
    let fontSize = 'normal';
    let kerningSize = 'normal';
    let colorTheme = null;

    return {
        init: function() {
            const module = this;
            const hasCookie = module.cookie().initiated();
            let cookieVal;

            module.cookie().json();

            if (hasCookie) {
                cookieVal = module.cookie().get();
                fontSize = cookieVal.fontsize;
                module.changeFontSize();
                kerningSize = cookieVal.kerning;
                module.changeKerningSize();
                $switcher.addClass('active');
                colorTheme = cookieVal.color;
                module.changeColorTheme();
                fontName = cookieVal.font;
                module.changeFontName();
                showImages = cookieVal.images;
                module.changeImagesView();
                module.setRoot();
            } else {
                fontSize = 'normal';
                kerningSize = 'normal';
                $(`.${kerningBtnClass}[data-kerning='${kerningSize}']`).addClass(kerningBtnActiveClass);
                $(`.${fontBtnClass}[data-fontsize='${fontSize}']`).addClass(fontBtnActiveClass);

            }

            module.themeSwitcherBtn(hasCookie);
            module.themeControls().init(hasCookie);

            $switcher.on('click', function() {
                var $this = $(this);
                const hasCookie = module.cookie().initiated();
                let isActive;

                $this.toggleClass('active');

                isActive = $this.hasClass('active');

                module.themeSwitcherBtn(isActive);
                module.themeControls().init(isActive);

                if (!isActive) {
                    showImages = true;
                    fontName = 'openSans';
                    fontSize = 'normal';
                    kerningSize = 'normal';
                    colorTheme = null;
                    module.cookie().delete();
                    $rootTag.html('');
                    $(`.${colorBtnClass}`).removeClass(colorBtnActiveClass);
                    $(`.${fontBtnClass}`).removeClass(fontBtnActiveClass);
                    $(`.${kerningBtnClass}`).removeClass(kerningBtnActiveClass);
                    module.changeImagesView();
                }

                if (!hasCookie) {
                    fontSize = 'normal';
                    kerningSize = 'normal';
                    $(`.${kerningBtnClass}[data-kerning='${kerningSize}']`).addClass(kerningBtnActiveClass);
                    $(`.${fontBtnClass}[data-fontsize='${fontSize}']`).addClass(fontBtnActiveClass);
                    $imageSwitcher.prop('checked', showImages);
                }

                if (isActive && !hasCookie) {
                    colorTheme = 'white';
                    module.changeColorTheme();
                }
            });
        },
        cookie: function() {
            return {
                json: function() {
                    $.cookie.json = true;
                },
                initiated: function() {
                    var cookie = this;

                    if (cookie.get() === undefined) {
                        return false;
                    } else {
                        return true;
                    }
                },
                set: function() {
                    var days = 1;

                    if (colorTheme && fontName && kerningSize && fontSize) {
                        $.cookie(cookieName, Object.assign(
                            {},
                            {
                                fontsize: fontSize,
                                color: colorTheme,
                                kerning: kerningSize,
                                images: showImages,
                                font: fontName
                            }
                        ), {
                            expires: days,
                            path: '/'
                        });
                    }
                },
                get: function() {
                    return $.cookie(cookieName);
                },
                delete: function() {
                    $.removeCookie(cookieName, { path: '/' });
                }
            };
        },
        changeFontName: function() {
            $('.contrast-version__font-family select').val(fontName);
        },
        themeControls: function() {
            var module = this;

            return {
                init: function(active) {
                    var themeControls = this;

                    if (active) {
                        module.panel().show();
                        themeControls.fontSize();
                        themeControls.kerningSize();
                        themeControls.imageControl();
                        themeControls.fontFamily();
                        themeControls.colorTheme();
                    } else {
                        module.panel().hide();
                    }
                },
                imageControl: function() {
                    $('.contrast-version__image-switcher input').on('change', (function() {
                        const $this = $(this);

                        showImages = $this.prop('checked');
                        module.changeImagesView();
                    }));
                },
                fontFamily: function() {
                    $('.contrast-version__font-family select').on('change', (function() {
                        const $this = $(this);

                        fontName = $this.val();
                        module.setRoot();
                    }));
                },
                kerningSize: function() {
                    $(`.${kerningBtnClass}`).on('click', (function() {
                        const $this = $(this);

                        kerningSize = $this.attr('data-kerning');
                        module.changeKerningSize();
                        module.setRoot();
                    }));
                },
                fontSize: function() {
                    $(`.${fontBtnClass}`).on('click', (function() {
                        const $this = $(this);

                        fontSize = $this.attr('data-fontsize');
                        module.changeFontSize();
                        module.setRoot();
                    }));
                },
                colorTheme: function() {
                    $(`.${colorBtnClass}`).each(function() {
                        $(this).on('click', (function() {
                            const $this = $(this);

                            colorTheme = $this.attr('data-color-theme');
                            module.changeColorTheme();
                            module.setRoot();
                        }));
                    });
                }
            };
        },
        setRoot: function() {
            let module = this;
            let root;

            if (colorTheme) {
                root = `:root {
                    --font-family: ${fonts[ fontName ]};
                    --font-size: ${fontSizes[ fontSize ]};
                    --letter-spacing: ${kerningSizes[ kerningSize ]};
                    --background: ${colors[ colorTheme ].text};
                    --font-color: ${colors[ colorTheme ].text};
                    --dark-color: ${colors[ colorTheme ].text};
                    --light-color: ${colors[ colorTheme ].main};
                    --link-color-negative: ${colors[ colorTheme ].text};
                    --main-color: ${colors[ colorTheme ].main};
                    --main-color--rgb: ${colors[ colorTheme ].main};
                    --success-color: ${colors[ colorTheme ].text};
                    --info-color: ${colors[ colorTheme ].text};
                    --danger-color: ${colors[ colorTheme ].text};
                    --warning-color: ${colors[ colorTheme ].text};
                    --primary-color: ${colors[ colorTheme ].text};
                    --primary-color--rgb: ${colors[ colorTheme ].text};
                    --secondary-color: ${colors[ colorTheme ].text};
                    --secondary-color--rgb: ${colors[ colorTheme ].text};
                    --visited-color: ${colors[ colorTheme ].text};
                    --button-color: ${colors[ colorTheme ].text};
                    --button-text-color--primary: ${colors[ colorTheme ].main};
                    --button-text-color--secondary: ${colors[ colorTheme ].main};
                    --button-text-color--40: ${colors[ colorTheme ].main};
                    --button-text-color--hover: ${colors[ colorTheme ].main};
                    --button-text-color--disabled: ${colors[ colorTheme ].text};
                    --button-border-bottom-color: ${colors[ colorTheme ].text};
                    --button-icon-color: ${colors[ colorTheme ].main};
                    --inverse-color:  ${colors[ colorTheme ].text};
                    --bg-color: ${colors[ colorTheme ].main};
                    --bg-color--1: ${colors[ colorTheme ].text};
                    --bg-color--2: ${colors[ colorTheme ].text};
                    --fb-color:  ${colors[ colorTheme ].text};
                    --fb-color--hover: ${colors[ colorTheme ].text};
                    --tw-color: ${colors[ colorTheme ].text};
                    --tw-color--hover: ${colors[ colorTheme ].text};
                    --yt-color: ${colors[ colorTheme ].text};
                    --yt-color--hover: ${colors[ colorTheme ].text};
                    --vk-color: ${colors[ colorTheme ].text};
                    --vk-color--hover: ${colors[ colorTheme ].text};
                    --ok-color: ${colors[ colorTheme ].text};
                    --ok-color--hover: ${colors[ colorTheme ].text};
                    --vm-color: ${colors[ colorTheme ].text};
                    --vm-color--hover: ${colors[ colorTheme ].text};
                    --gg-color: ${colors[ colorTheme ].text};
                    --gg-color--hover: ${colors[ colorTheme ].text};
                    --pdf-color: ${colors[ colorTheme ].text};
                    --word-color: ${colors[ colorTheme ].text};
                    --excel-color: ${colors[ colorTheme ].text};
                    --pp-color: ${colors[ colorTheme ].text};
                    --link-color: ${colors[ colorTheme ].text};
                    --arch-color: ${colors[ colorTheme ].text};
                    --top-panel-font-color: ${colors[ colorTheme ].text};
                    --special-section-title-background-color: ${colors[ colorTheme ].main};
                }`;

                module.cookie().set(colorTheme, fontSize, kerningSize, showImages, fontName);
            } else {
                root = `:root {
                    --font-family: ${fonts[ fontName ]};
                    --font-size: ${fontSizes[ fontSize ]};
                    --letter-spacing: ${kerningSizes[ kerningSize ]};
                }`;
            }

            $rootTag.html(root);

            function hex2rgb(color) {
                const str = color.replace('#', '');

                return str.split('').reduce(function(result, char, index, array) {
                    const j = parseInt(index * 3 / array.length);
                    const number = parseInt(char, 16);

                    result[ j ] = (array.length == 3 ? number : result[ j ]) * 16 + number;
                    return result;
                }, [ 0, 0, 0 ]);
            }
        },
        changeImagesView: function() {
            var module = this;

            $imageSwitcher.prop('checked', showImages);

            imagesBlocks.forEach((block) => {
                if (showImages) {
                    $(`.${block}`).removeClass(`${block}--contrast-version-no-images`);
                } else {
                    $(`.${block}`).addClass(`${block}--contrast-version-no-images`);
                }
            });

            $('.contrast-version__image-block').remove();

            $('img').each(function() {
                const $this = $(this);
                const style = $this[ 0 ].hasAttribute('style') ? $this.attr('style') : '';
                const alt = $this[ 0 ].hasAttribute('alt') ? $this.attr('alt').trim() : '';
                const src = _.last($this.attr('src').split('/'));
                const div = (title) => $(`<div class="contrast-version__image-block" style="${style}"><span>${title}</span></div>`);

                if (showImages) {
                    $this.removeClass('contrast-version__image');
                } else {
                    if (!$this.hasClass('no-image')) {
                        if (alt.length) {
                            $this.after(div(alt));
                        } else {
                            $this.after(div(src));
                        }
                        $this.addClass('contrast-version__image');
                    }
                }
            });

            module.setRoot();
        },
        changeFontSize: function() {
            var module = this;

            $(`.${fontBtnClass}`).removeClass(fontBtnActiveClass);
            $(`.${fontBtnClass}[data-fontsize="${fontSize}"]`).addClass(fontBtnActiveClass);
            module.setRoot();
        },
        changeKerningSize: function() {
            var module = this;

            $(`.${kerningBtnClass}`).removeClass(kerningBtnActiveClass);
            $(`.${kerningBtnClass}[data-kerning="${kerningSize}"]`).addClass(kerningBtnActiveClass);
            module.setRoot();
        },
        changeColorTheme: function() {
            var module = this;

            $(`.${colorBtnClass}`).removeClass(colorBtnActiveClass);
            $(`.${colorBtnClass}[data-color-theme='${colorTheme}']`).addClass(colorBtnActiveClass);
            module.setRoot();
        },
        themeSwitcherBtn: function(active) {
            const $btn = $themeSwitcher.find('span');
            const $btnIcon = $themeSwitcher.find('.icons');

            if (active) {
                $btn.text($btn.attr('data-text-normal'));
                $btnIcon.removeClass('icon-glasses').addClass('icon-eye-1');
            } else {
                $btn.text($btn.attr('data-text-contrast'));
                $btnIcon.removeClass('icon-eye-1').addClass('icon-glasses');
            }
        },
        panel: function() {
            return {
                show: function() {
                    $panel.removeClass(panelHideClass);
                },
                hide: function() {
                    $panel.addClass(panelHideClass);
                }
            };
        }
    };
}



// WEBPACK FOOTER //
// ./frontend/src/js/modules/theme-switcher.js